<template>
  <span
    :class="sizeClass"
    class="inline-flex flex-none items-center justify-center bg-brand-50 font-display font-bold text-brand-700"
  >
    <icon
      v-if="iconName"
      :name="iconName"
      aria-hidden="true"
      :class="iconSizeClass"
    />

    <slot v-else />
  </span>
</template>

<script setup lang="ts">
import type { IconSquareProps } from 'types/section'

const { iconName, size = 'md' } = defineProps<IconSquareProps>()

const sizeClass = computed<string>(() => {
  if (size === 'sm') return 'size-9 rounded-xl text-sm'
  if (size === 'lg') return 'size-14 rounded-2xl text-xl'

  return 'size-12 rounded-2xl text-base'
})

const iconSizeClass = computed<string>(() => {
  if (size === 'sm') return 'size-5'
  if (size === 'lg') return 'size-7'

  return 'size-6'
})
</script>
